export const localStorageNames = {
  authentication: 'authentication',
  refreshToken: 'refreshToken',
};
